import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from '../auth/PrivateRoute/PrivateRoute';
import {
  Home,
  ErrorPage,
  SignIn,
  Help,
  Settings,
  ProtocolList,
  Protocol,
  Deceased,
  Management,
  Statistics
} from '../../pages';

const router: JSX.Element[] = [
  <Route
    key={1}
    path="/"
    element={<PrivateRoute component={<Home />} />}
    errorElement={<ErrorPage />}
  />,
  <Route key={2} path="/signin" element={<SignIn />} errorElement={<ErrorPage />} />,

  <Route
    key={3}
    path="/deceased"
    element={<PrivateRoute component={<Deceased />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={3}
    path="/deceased/:id"
    element={<PrivateRoute component={<Deceased />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={7}
    path="/protocol/:id/:page"
    element={<PrivateRoute component={<Protocol />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={4}
    path="/protocol-list"
    element={<PrivateRoute component={<ProtocolList />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={5}
    path="/settings"
    element={<PrivateRoute component={<Settings />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={6}
    path="/help"
    element={<PrivateRoute component={<Help />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={8}
    path="/management"
    element={<PrivateRoute component={<Management />} />}
    errorElement={<ErrorPage />}
  />,

  <Route
    key={9}
    path="/management/:tab"
    element={<PrivateRoute component={<Management />} />}
    errorElement={<ErrorPage />}
  />,

  <Route 
    key={10} path="/statistics" 
    element={<PrivateRoute component={<Statistics />} />}
    errorElement={<ErrorPage />}
  />
];

export const RouterManager: React.FC = () => {
  return <Routes>{router}</Routes>;
};
